import {
  COMMENTS_DOMAIN,
  COMMENTS_PATH
} from 'modules/comments/constants'
import { getSectionDomainMapValueListPathReduxUtil } from 'modules/redux/utils/legacy/get-section-domain-map-value-list-path'
import { getObjectUtil } from 'packages/src'

function getPathWithoutDomain (path) {
  return path.slice(path.indexOf('.') + 1)
}

/**
 * Gets the new Comment for the given instance.
 * @param  {Domain} comments
 * @param  {Instance|null} instance
 * @returns {Comment|null}
 */
function getNewCommentsUtil (comments, instance) {
  if (!instance) {
    return
  }
  // Get the new `Comment`'s id
  let newPath = getNewPathCommentsUtil(instance)
  newPath = getPathWithoutDomain(newPath)
  const id = getObjectUtil(comments, newPath)
  // Get the new `Comment`
  let path = getPathCommentsUtil(id)
  path = getPathWithoutDomain(path)
  return getObjectUtil(comments, path)
}

/**
 * Get the `DomainNew`'s path.
 * @param  {Instance} instance
 * @returns {string}
 */
function getNewPathCommentsUtil (instance) {
  return `${getDomainListPathCommentsUtil(instance)}.new`
}

/**
 * Get the `Instance's `DomainList`'s path.
 * @param  {Instance} instance
 * @returns {string}
 */
function getDomainListPathCommentsUtil (instance) {
  return getSectionDomainMapValueListPathReduxUtil(COMMENTS_DOMAIN, instance)
}

/**
 * Get the `Instance's `DomainList`'s data path.
 * @param  {Instance} instance
 * @returns {string}
 */
function getDomainListDataPathCommentsUtil (instance) {
  return `${getDomainListPathCommentsUtil(instance)}.data`
}

/**
 * Gets the `Comment` path using the given id.
 * @param  {number} id
 * @returns {string}
 */
function getPathCommentsUtil (id) {
  return `${COMMENTS_PATH.DATA}.${id}`
}

/**
 * Gets the `Report` of the given `Comment`.
 * @param  {Comment} comment
 * @param  {DomainMap} reports
 * @param  {User} currentUser
 * @returns {Report|null}
 */
function getReportCommentsUtil (comment, reports, currentUser) {
  if (!comment || !currentUser) {
    return
  }
  const reportIds = (
    getObjectUtil(reports.comments, `${comment.data.id}.data`) || []
  )
  return reportIds.find(reportId =>
    reports.data[reportId].data.userId === currentUser.data.id
  )
}

export {
  getNewCommentsUtil,
  getNewPathCommentsUtil,
  getDomainListPathCommentsUtil,
  getDomainListDataPathCommentsUtil,
  getPathCommentsUtil,
  getReportCommentsUtil
}
